import { render, staticRenderFns } from "./ImageDialog.vue?vue&type=template&id=4bc3ac17&scoped=true"
import script from "./ImageDialog.vue?vue&type=script&lang=js"
export * from "./ImageDialog.vue?vue&type=script&lang=js"
import style0 from "./ImageDialog.vue?vue&type=style&index=0&id=4bc3ac17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc3ac17",
  null
  
)

export default component.exports